import { PaletteOptions, SimplePaletteColorOptions } from '@mui/material'

export enum PaletteType {
  primary = 'primary',
  warning = 'warning',
  error = 'error',
  success = 'success',
  secondary = 'secondary',
  info = 'info',
  grey = 'grey'

  // Custom palette  colors
  // brand = 'brand'
}

type PaletteNumberColors = { [key: number]: string }

const ColorNumberArray = [25, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950]

function getCSSVar(varName: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(varName)
}

function getCSSVarByNumbers(palette: string): PaletteNumberColors {
  const values: PaletteNumberColors = {}
  ColorNumberArray.forEach(number => {
    values[number] = getComputedStyle(document.documentElement).getPropertyValue(
      `--${palette}-${number}`
    )
  })
  return values
}

function getPaletteVar(palette: string): SimplePaletteColorOptions {
  return {
    light: getCSSVar(`--${palette}-light`),
    main: getCSSVar(`--${palette}-main`),
    dark: getCSSVar(`--${palette}-dark`),
    contrastText: getCSSVar(`--${palette}-contrastText`),
    ...getCSSVarByNumbers(palette)
  }
}

export function buildPalette(): PaletteOptions {
  return {
    primary: getPaletteVar('primary'),
    secondary: getPaletteVar('secondary'),
    info: getPaletteVar('info'),
    error: getPaletteVar('error'),
    warning: getPaletteVar('warning'),
    success: getPaletteVar('success'),
    common: {
      black: getCSSVar('--common-black'),
      white: getCSSVar('--common-white')
    },
    grey: {
      25: getCSSVar('--grey-25'),
      50: getCSSVar('--grey-50'),
      100: getCSSVar('--grey-100'),
      200: getCSSVar('--grey-200'),
      300: getCSSVar('--grey-300'),
      400: getCSSVar('--grey-400'),
      500: getCSSVar('--grey-500'),
      600: getCSSVar('--grey-600'),
      700: getCSSVar('--grey-700'),
      800: getCSSVar('--grey-800'),
      900: getCSSVar('--grey-900'),
      950: getCSSVar('--grey-950'),
      A100: getCSSVar('--grey-A100'),
      A200: getCSSVar('--grey-A200'),
      A400: getCSSVar('--grey-A400'),
      A700: getCSSVar('--grey-A700')
    },
    background: {
      default: getCSSVar('--grey-25')
    }

    // Add Custom palette colors
    // brand: getPaletteVar('brand'),
  }
}

const PaletteTheme: PaletteOptions = buildPalette()

export default PaletteTheme
